import { ContainerPlugin, Events, Playback, UICorePlugin, template, Styler, CorePlugin, PlayerError, $, Utils, Browser, UIContainerPlugin } from '@clappr/core';

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

class ClickToPausePlugin extends ContainerPlugin {
  get name() {
    return 'click_to_pause';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get config() {
    return this.container.options.clickToPauseConfig || {};
  }
  bindEvents() {
    this.listenTo(this.container, Events.CONTAINER_CLICK, this.click);
    this.listenTo(this.container, Events.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
  }
  click() {
    const onClickPayload = this.config.onClickPayload;
    if (this.container.getPlaybackType() !== Playback.LIVE || this.container.isDvrEnabled()) {
      if (this.container.isPlaying()) {
        this.container.pause(onClickPayload);
      } else {
        this.container.play(onClickPayload);
      }
    }
  }
  settingsUpdate() {
    const pointerEnabled = this.container.getPlaybackType() !== Playback.LIVE || this.container.isDvrEnabled();
    if (pointerEnabled === this.pointerEnabled) return;
    const method = pointerEnabled ? 'addClass' : 'removeClass';
    this.container.$el[method]('pointer-enabled');
    this.pointerEnabled = pointerEnabled;
  }
}

var ccIcon = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 49 41.8\" style=\"enable-background:new 0 0 49 41.8;\" xml:space=\"preserve\">\n<path d=\"M47.1,0H3.2C1.6,0,0,1.2,0,2.8v31.5C0,35.9,1.6,37,3.2,37h11.9l3.2,1.9l4.7,2.7c0.9,0.5,2-0.1,2-1.1V37h22.1\n\tc1.6,0,1.9-1.1,1.9-2.7V2.8C49,1.2,48.7,0,47.1,0z M7.2,18.6c0-4.8,3.5-9.3,9.9-9.3c4.8,0,7.1,2.7,7.1,2.7l-2.5,4\n\tc0,0-1.7-1.7-4.2-1.7c-2.8,0-4.3,2.1-4.3,4.3c0,2.1,1.5,4.4,4.5,4.4c2.5,0,4.9-2.1,4.9-2.1l2.2,4.2c0,0-2.7,2.9-7.6,2.9\n\tC10.8,27.9,7.2,23.5,7.2,18.6z M36.9,27.9c-6.4,0-9.9-4.4-9.9-9.3c0-4.8,3.5-9.3,9.9-9.3C41.7,9.3,44,12,44,12l-2.5,4\n\tc0,0-1.7-1.7-4.2-1.7c-2.8,0-4.3,2.1-4.3,4.3c0,2.1,1.5,4.4,4.5,4.4c2.5,0,4.9-2.1,4.9-2.1l2.2,4.2C44.5,25,41.9,27.9,36.9,27.9z\"/>\n</svg>";

var ccHTML = "<button type=\"button\" class=\"cc-button media-control-button media-control-icon\" data-cc-button aria-label=\"<%= ariaLabel %>\"></button>\n<ul>\n  <% if (title) { %>\n  <li data-title><%= title %></li>\n  <% }; %>\n  <li><a href=\"#\" data-cc-select=\"-1\"><%= disabledLabel %></a></li>\n  <% for (var i = 0; i < tracks.length; i++) { %>\n    <li><a href=\"#\" data-cc-select=\"<%= tracks[i].id %>\"><%= tracks[i].label %></a></li>\n  <% }; %>\n</ul>\n";

var css_248z$7 = ".cc-controls[data-cc-controls] {\n  float: right;\n  position: relative;\n  display: none;\n}\n.cc-controls[data-cc-controls].available {\n  display: block;\n}\n.cc-controls[data-cc-controls] .cc-button {\n  padding: 6px !important;\n}\n.cc-controls[data-cc-controls] .cc-button.enabled {\n  display: block;\n  opacity: 1;\n}\n.cc-controls[data-cc-controls] .cc-button.enabled:hover {\n  opacity: 1;\n  text-shadow: none;\n}\n.cc-controls[data-cc-controls] > ul {\n  list-style-type: none;\n  position: absolute;\n  bottom: 25px;\n  border: 1px solid black;\n  display: none;\n  background-color: #e6e6e6;\n}\n.cc-controls[data-cc-controls] li {\n  font-size: 10px;\n}\n.cc-controls[data-cc-controls] li[data-title] {\n  background-color: #c3c2c2;\n  padding: 5px;\n}\n.cc-controls[data-cc-controls] li a {\n  color: #444;\n  padding: 2px 10px;\n  display: block;\n  text-decoration: none;\n}\n.cc-controls[data-cc-controls] li a:hover {\n  background-color: #555;\n  color: white;\n}\n.cc-controls[data-cc-controls] li a:hover a {\n  color: white;\n  text-decoration: none;\n}\n.cc-controls[data-cc-controls] li.current a {\n  color: #f00;\n}";

class ClosedCaptions extends UICorePlugin {
  get name() {
    return 'closed_captions';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get template() {
    return template(ccHTML);
  }
  get events() {
    return {
      'click [data-cc-button]': 'toggleContextMenu',
      'click [data-cc-select]': 'onTrackSelect'
    };
  }
  get attributes() {
    return {
      'class': 'cc-controls',
      'data-cc-controls': ''
    };
  }
  constructor(core) {
    super(core);
    const config = core.options.closedCaptionsConfig;
    this._title = config && config.title ? config.title : null;
    this._ariaLabel = config && config.ariaLabel ? config.ariaLabel : 'cc-button';
    this._labelCb = config && config.labelCallback && typeof config.labelCallback === 'function' ? config.labelCallback : track => {
      return track.name;
    };
  }
  bindEvents() {
    this.listenTo(this.core, Events.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
    this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_RENDERED, this.render);
    this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_HIDE, this.hideContextMenu);
    this.bindContainerEvents();
  }
  bindContainerEvents() {
    this.container = this.core.activeContainer;
    if (this.container) {
      this.listenTo(this.container, Events.CONTAINER_SUBTITLE_AVAILABLE, this.onSubtitleAvailable);
      this.listenTo(this.container, Events.CONTAINER_SUBTITLE_CHANGED, this.onSubtitleChanged);
      this.listenTo(this.container, Events.CONTAINER_STOP, this.onContainerStop);
    }
  }
  onContainerStop() {
    this.ccAvailable(false);
  }
  containerChanged() {
    this.ccAvailable(false);
    this.stopListening();
    this.bindEvents();
  }
  onSubtitleAvailable() {
    this.renderCcButton();
    this.ccAvailable(true);
  }
  onSubtitleChanged(track) {
    this.setCurrentContextMenuElement(track.id);
  }
  onTrackSelect(event) {
    const trackId = parseInt(event.target.dataset.ccSelect, 10);
    this.container.closedCaptionsTrackId = trackId;
    this.hideContextMenu();
    event.stopPropagation();
    return false;
  }
  ccAvailable(hasCC) {
    const method = hasCC ? 'addClass' : 'removeClass';
    this.$el[method]('available');
  }
  toggleContextMenu() {
    this.$el.find('ul').toggle();
  }
  hideContextMenu() {
    this.$el.find('ul').hide();
  }
  contextMenuElement(id) {
    return this.$el.find('ul a' + (!isNaN(id) ? '[data-cc-select="' + id + '"]' : '')).parent();
  }
  setCurrentContextMenuElement(trackId) {
    if (this._trackId !== trackId) {
      this.contextMenuElement().removeClass('current');
      this.contextMenuElement(trackId).addClass('current');
      const method = trackId > -1 ? 'addClass' : 'removeClass';
      this.$ccButton[method]('enabled');
      this._trackId = trackId;
    }
  }
  renderCcButton() {
    const tracks = this.container ? this.container.closedCaptionsTracks : [];
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].label = this._labelCb(tracks[i]);
    }
    const style = Styler.getStyleFor(css_248z$7, {
      baseUrl: this.options.baseUrl
    });
    this.$el.html(this.template({
      ariaLabel: this._ariaLabel,
      disabledLabel: this.core.i18n.t('disabled'),
      title: this._title,
      tracks: tracks
    }));
    this.$ccButton = this.$el.find('button.cc-button[data-cc-button]');
    this.$ccButton.append(ccIcon);
    this.$el.append(style[0]);
  }
  render() {
    this.renderCcButton();
    const $fullscreen = this.core.mediaControl.$el.find('button[data-fullscreen]');
    if ($fullscreen[0]) {
      this.$el.insertAfter($fullscreen);
    } else {
      this.core.mediaControl.$el.find('.media-control-right-panel[data-media-control]').prepend(this.$el);
    }
    return this;
  }
}

var dvrHTML = "<div class=\"live-info\"><%= live %></div>\n<button type=\"button\" class=\"live-button\" aria-label=\"<%= backToLive %>\"><%= backToLive %></button>\n";

var css_248z$6 = ".dvr-controls[data-dvr-controls] {\n  display: inline-block;\n  float: left;\n  color: #fff;\n  line-height: 32px;\n  font-size: 10px;\n  font-weight: bold;\n  margin-left: 6px;\n}\n.dvr-controls[data-dvr-controls] .live-info {\n  cursor: default;\n  font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n  text-transform: uppercase;\n}\n.dvr-controls[data-dvr-controls] .live-info:before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  width: 7px;\n  height: 7px;\n  border-radius: 3.5px;\n  margin-right: 3.5px;\n  background-color: #ff0101;\n}\n.dvr-controls[data-dvr-controls] .live-info.disabled {\n  opacity: 0.3;\n}\n.dvr-controls[data-dvr-controls] .live-info.disabled:before {\n  background-color: #fff;\n}\n.dvr-controls[data-dvr-controls] .live-button {\n  cursor: pointer;\n  outline: none;\n  display: none;\n  border: 0;\n  color: #fff;\n  background-color: transparent;\n  height: 32px;\n  padding: 0;\n  opacity: 0.7;\n  font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n  text-transform: uppercase;\n  transition: all 0.1s ease;\n}\n.dvr-controls[data-dvr-controls] .live-button:before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  width: 7px;\n  height: 7px;\n  border-radius: 3.5px;\n  margin-right: 3.5px;\n  background-color: #fff;\n}\n.dvr-controls[data-dvr-controls] .live-button:hover {\n  opacity: 1;\n  text-shadow: rgba(255, 255, 255, 0.75) 0 0 5px;\n}\n\n.dvr .dvr-controls[data-dvr-controls] .live-info {\n  display: none;\n}\n.dvr .dvr-controls[data-dvr-controls] .live-button {\n  display: block;\n}\n.dvr.media-control.live[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #005aff;\n}\n\n.media-control.live[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #ff0101;\n}";

class DVRControls extends UICorePlugin {
  get template() {
    return template(dvrHTML);
  }
  get name() {
    return 'dvr_controls';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get events() {
    return {
      'click .live-button': 'click'
    };
  }
  get attributes() {
    return {
      'class': 'dvr-controls',
      'data-dvr-controls': ''
    };
  }
  constructor(core) {
    super(core);
    this.settingsUpdate();
  }
  bindEvents() {
    this.bindCoreEvents();
    this.bindContainerEvents();
  }
  bindCoreEvents() {
    if (this.core.mediaControl.settings) {
      this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_CONTAINERCHANGED, this.containerChanged);
      this.listenTo(this.core.mediaControl, Events.MEDIACONTROL_RENDERED, this.settingsUpdate);
      this.listenTo(this.core, Events.CORE_OPTIONS_CHANGE, this.render);
    } else {
      setTimeout(() => this.bindCoreEvents(), 100);
    }
  }
  bindContainerEvents() {
    if (this.core.activeContainer) {
      this.listenToOnce(this.core.activeContainer, Events.CONTAINER_TIMEUPDATE, this.render);
      this.listenTo(this.core.activeContainer, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, this.dvrChanged);
    }
  }
  containerChanged() {
    this.stopListening();
    this.bindEvents();
  }
  dvrChanged(dvrEnabled) {
    if (this.core.getPlaybackType() !== Playback.LIVE) return;
    this.settingsUpdate();
    this.core.mediaControl.$el.addClass('live');
    if (dvrEnabled) {
      this.core.mediaControl.$el.addClass('dvr');
      this.core.mediaControl.$el.find('.media-control-indicator[data-position], .media-control-indicator[data-duration]').hide();
    } else {
      this.core.mediaControl.$el.removeClass('dvr');
    }
  }
  click() {
    const mediaControl = this.core.mediaControl;
    const container = mediaControl.container;
    if (!container.isPlaying()) {
      container.play();
    }
    if (mediaControl.$el.hasClass('dvr')) {
      container.seek(container.getDuration());
    }
  }
  settingsUpdate() {
    this.stopListening();
    this.core.mediaControl.$el.removeClass('live');
    if (this.shouldRender()) {
      this.render();
      this.$el.click(() => this.click());
    }
    this.bindEvents();
  }
  shouldRender() {
    const useDvrControls = this.core.options.useDvrControls === undefined || !!this.core.options.useDvrControls;
    return useDvrControls && this.core.getPlaybackType() === Playback.LIVE;
  }
  render() {
    const style = Styler.getStyleFor(css_248z$6, {
      baseUrl: this.options.baseUrl
    });
    this.$el.html(this.template({
      live: this.core.i18n.t('live'),
      backToLive: this.core.i18n.t('back_to_live')
    }));
    this.$el.append(style[0]);
    if (this.shouldRender()) {
      this.core.mediaControl.$el.addClass('live');
      this.core.mediaControl.$('.media-control-left-panel[data-media-control]').append(this.$el);
    }
    return this;
  }
}

class EndVideo extends CorePlugin {
  get name() {
    return 'end_video';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  bindEvents() {
    this.listenTo(this.core, Events.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
    const container = this.core.activeContainer;
    if (container) {
      this.listenTo(container, Events.CONTAINER_ENDED, this.ended);
      this.listenTo(container, Events.CONTAINER_STOP, this.ended);
    }
  }
  containerChanged() {
    this.stopListening();
    this.bindEvents();
  }
  ended() {
    const exitOnEnd = typeof this.core.options.exitFullscreenOnEnd === 'undefined' || this.core.options.exitFullscreenOnEnd;
    if (exitOnEnd && this.core.isFullscreen()) {
      this.core.toggleFullscreen();
    }
  }
}

var reloadIcon = "<svg fill=\"#FFFFFF\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z\"/>\n    <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n</svg>";

var templateHtml = "<div class=\"player-error-screen__content\" data-error-screen>\n  <% if (icon) { %>\n  <div class=\"player-error-screen__icon\" data-error-screen><%= icon %></div>\n  <% } %>\n  <div class=\"player-error-screen__title\" data-error-screen><%= title %></div>\n  <div class=\"player-error-screen__message\" data-error-screen><%= message %></div>\n  <div class=\"player-error-screen__code\" data-error-screen>Error code: <%= code %></div>\n  <div class=\"player-error-screen__reload\" data-error-screen><%= reloadIcon %></div>\n</div>\n";

var css_248z$5 = "[data-player] .player-error-screen {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #CCCACA;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n[data-player] .player-error-screen__content[data-error-screen] {\n  font-size: 14px;\n  color: #CCCACA;\n  margin-top: 45px;\n}\n[data-player] .player-error-screen__title[data-error-screen] {\n  font-weight: bold;\n  line-height: 30px;\n  font-size: 18px;\n}\n[data-player] .player-error-screen__message[data-error-screen] {\n  width: 90%;\n  margin: 0 auto;\n}\n[data-player] .player-error-screen__code[data-error-screen] {\n  font-size: 13px;\n  margin-top: 15px;\n}\n[data-player] .player-error-screen__reload {\n  cursor: pointer;\n  width: 30px;\n  margin: 15px auto 0 !important;\n}";

class ErrorScreen extends UICorePlugin {
  get name() {
    return 'error_screen';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get template() {
    return template(templateHtml);
  }
  get container() {
    return this.core.getCurrentContainer();
  }
  get attributes() {
    return {
      'class': 'player-error-screen',
      'data-error-screen': ''
    };
  }
  constructor(core) {
    super(core);
    if (this.options.disableErrorScreen) return this.disable();
  }
  bindEvents() {
    this.listenTo(this.core, Events.ERROR, this.onError);
    this.listenTo(this.core, Events.CORE_ACTIVE_CONTAINER_CHANGED, this.onContainerChanged);
  }
  bindReload() {
    this.reloadButton = this.$el.find('.player-error-screen__reload');
    this.reloadButton && this.reloadButton.on('click', this.reload.bind(this));
  }
  reload() {
    this.listenToOnce(this.core, Events.CORE_READY, () => this.container.play());
    this.core.load(this.options.sources, this.options.mimeType);
    this.unbindReload();
  }
  unbindReload() {
    this.reloadButton && this.reloadButton.off('click');
  }
  onContainerChanged() {
    this.err = null;
    this.unbindReload();
    this.hide();
  }
  onError(err = {}) {
    if (err.level === PlayerError.Levels.FATAL) {
      this.err = err;
      this.container.disableMediaControl();
      this.container.stop();
      this.show();
    }
  }
  show() {
    this.render();
    this.$el.show();
  }
  hide() {
    this.$el.hide();
  }
  render() {
    if (!this.err) return;
    const style = Styler.getStyleFor(css_248z$5, {
      baseUrl: this.options.baseUrl
    });
    this.$el.html(this.template({
      title: this.err.UI.title,
      message: this.err.UI.message,
      code: this.err.code,
      icon: this.err.UI.icon || '',
      reloadIcon
    }));
    this.$el.append(style[0]);
    this.core.$el.append(this.el);
    this.bindReload();
    return this;
  }
}

var playIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M1.425.35L14.575 8l-13.15 7.65V.35z\"/>\n</svg>";

var pauseIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 14.76H6.43V1.24H1.71v13.52zm7.86-13.52v13.52h4.716V1.24H9.573z\"/>\n</svg>";

const oldIcon = $('link[rel="shortcut icon"]');
class Favicon extends CorePlugin {
  get name() {
    return 'favicon';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get oldIcon() {
    return oldIcon;
  }
  constructor(core) {
    super(core);
    this._container = null;
    this.configure();
  }
  configure() {
    if (this.core.options.changeFavicon) {
      if (!this.enabled) {
        this.stopListening(this.core, Events.CORE_OPTIONS_CHANGE);
        this.enable();
      }
    } else if (this.enabled) {
      this.disable();
      this.listenTo(this.core, Events.CORE_OPTIONS_CHANGE, this.configure);
    }
  }
  bindEvents() {
    this.listenTo(this.core, Events.CORE_OPTIONS_CHANGE, this.configure);
    this.listenTo(this.core, Events.CORE_ACTIVE_CONTAINER_CHANGED, this.containerChanged);
    this.core.activeContainer && this.containerChanged();
  }
  containerChanged() {
    this._container && this.stopListening(this._container);
    this._container = this.core.activeContainer;
    this.listenTo(this._container, Events.CONTAINER_PLAY, this.setPlayIcon);
    this.listenTo(this._container, Events.CONTAINER_PAUSE, this.setPauseIcon);
    this.listenTo(this._container, Events.CONTAINER_STOP, this.resetIcon);
    this.listenTo(this._container, Events.CONTAINER_ENDED, this.resetIcon);
    this.listenTo(this._container, Events.CONTAINER_ERROR, this.resetIcon);
    this.resetIcon();
  }
  disable() {
    super.disable();
    this.resetIcon();
  }
  destroy() {
    super.destroy();
    this.resetIcon();
  }
  createIcon(svg) {
    const canvas = $('<canvas/>');
    canvas[0].width = 16;
    canvas[0].height = 16;
    const ctx = canvas[0].getContext('2d');
    ctx.fillStyle = '#000';
    const d = $(svg).find('path').attr('d');
    const path = new Path2D(d);
    ctx.fill(path);
    const icon = $('<link rel="shortcut icon" type="image/png"/>');
    icon.attr('href', canvas[0].toDataURL('image/png'));
    return icon;
  }
  setPlayIcon() {
    if (!this.playIcon) {
      this.playIcon = this.createIcon(playIcon);
    }
    this.changeIcon(this.playIcon);
  }
  setPauseIcon() {
    if (!this.pauseIcon) {
      this.pauseIcon = this.createIcon(pauseIcon);
    }
    this.changeIcon(this.pauseIcon);
  }
  resetIcon() {
    $('link[rel="shortcut icon"]').remove();
    $('head').append(this.oldIcon);
  }
  changeIcon(icon) {
    if (icon) {
      $('link[rel="shortcut icon"]').remove();
      $('head').append(icon);
    }
  }
}

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

class GoogleAnalytics extends ContainerPlugin {
  get name() {
    return 'google_analytics';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  constructor(container) {
    super(container);
    if (this.container.options.gaAccount) {
      this.account = this.container.options.gaAccount;
      this.trackerName = this.container.options.gaTrackerName ? this.container.options.gaTrackerName + '.' : 'Clappr.';
      this.domainName = this.container.options.gaDomainName;
      this.currentHDState = undefined;
      this.embedScript();
    }
  }
  embedScript() {
    if (!window._gat) {
      const script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('async', 'async');
      script.setAttribute('src', '//www.google-analytics.com/ga.js');
      script.onload = () => this.addEventListeners();
      document.body.appendChild(script);
    } else {
      this.addEventListeners();
    }
  }
  addEventListeners() {
    if (this.container) {
      this.listenTo(this.container, Events.CONTAINER_READY, this.onReady);
      this.listenTo(this.container, Events.CONTAINER_PLAY, this.onPlay);
      this.listenTo(this.container, Events.CONTAINER_STOP, this.onStop);
      this.listenTo(this.container, Events.CONTAINER_PAUSE, this.onPause);
      this.listenTo(this.container, Events.CONTAINER_ENDED, this.onEnded);
      this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERING, this.onBuffering);
      this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERFULL, this.onBufferFull);
      this.listenTo(this.container, Events.CONTAINER_ERROR, this.onError);
      this.listenTo(this.container, Events.CONTAINER_PLAYBACKSTATE, this.onPlaybackChanged);
      this.listenTo(this.container, Events.CONTAINER_VOLUME, event => this.onVolumeChanged(event));
      this.listenTo(this.container, Events.CONTAINER_SEEK, event => this.onSeek(event));
      this.listenTo(this.container, Events.CONTAINER_FULL_SCREEN, this.onFullscreen);
      this.listenTo(this.container, Events.CONTAINER_HIGHDEFINITIONUPDATE, this.onHD);
      this.listenTo(this.container, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, this.onDVR);
    }
    _gaq.push([this.trackerName + '_setAccount', this.account]);
    if (this.domainName) {
      _gaq.push([this.trackerName + '_setDomainName', this.domainName]);
    }
  }
  onReady() {
    this.push(['Video', 'Playback', this.container.playback.name]);
  }
  onPlay() {
    this.push(['Video', 'Play', this.container.playback.src]);
  }
  onStop() {
    this.push(['Video', 'Stop', this.container.playback.src]);
  }
  onEnded() {
    this.push(['Video', 'Ended', this.container.playback.src]);
  }
  onBuffering() {
    this.push(['Video', 'Buffering', this.container.playback.src]);
  }
  onBufferFull() {
    this.push(['Video', 'Bufferfull', this.container.playback.src]);
  }
  onError() {
    this.push(['Video', 'Error', this.container.playback.src]);
  }
  onHD(isHD) {
    const status = isHD ? 'ON' : 'OFF';
    if (status !== this.currentHDState) {
      this.currentHDState = status;
      this.push(['Video', 'HD - ' + status, this.container.playback.src]);
    }
  }
  onPlaybackChanged(playbackState) {
    if (playbackState.type !== null) {
      this.push(['Video', 'Playback Type - ' + playbackState.type, this.container.playback.src]);
    }
  }
  onDVR(dvrInUse) {
    const status = dvrInUse ? 'ON' : 'OFF';
    this.push(['Interaction', 'DVR - ' + status, this.container.playback.src]);
  }
  onPause() {
    this.push(['Video', 'Pause', this.container.playback.src]);
  }
  onSeek() {
    this.push(['Video', 'Seek', this.container.playback.src]);
  }
  onVolumeChanged() {
    this.push(['Interaction', 'Volume', this.container.playback.src]);
  }
  onFullscreen() {
    this.push(['Interaction', 'Fullscreen', this.container.playback.src]);
  }
  push(array) {
    const res = [this.trackerName + '_trackEvent'].concat(array);
    _gaq.push(res);
  }
}

/* eslint-disable */
// Kibo is released under the MIT License. Copyright (c) 2013 marquete.
// see https://github.com/marquete/kibo

var Kibo = function (element) {
  this.element = element || window.document;
  this.initialize();
};
Kibo.KEY_NAMES_BY_CODE = {
  8: 'backspace',
  9: 'tab',
  13: 'enter',
  16: 'shift',
  17: 'ctrl',
  18: 'alt',
  20: 'caps_lock',
  27: 'esc',
  32: 'space',
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
  48: '0',
  49: '1',
  50: '2',
  51: '3',
  52: '4',
  53: '5',
  54: '6',
  55: '7',
  56: '8',
  57: '9',
  65: 'a',
  66: 'b',
  67: 'c',
  68: 'd',
  69: 'e',
  70: 'f',
  71: 'g',
  72: 'h',
  73: 'i',
  74: 'j',
  75: 'k',
  76: 'l',
  77: 'm',
  78: 'n',
  79: 'o',
  80: 'p',
  81: 'q',
  82: 'r',
  83: 's',
  84: 't',
  85: 'u',
  86: 'v',
  87: 'w',
  88: 'x',
  89: 'y',
  90: 'z',
  112: 'f1',
  113: 'f2',
  114: 'f3',
  115: 'f4',
  116: 'f5',
  117: 'f6',
  118: 'f7',
  119: 'f8',
  120: 'f9',
  121: 'f10',
  122: 'f11',
  123: 'f12'
};
Kibo.KEY_CODES_BY_NAME = {};
(function () {
  for (var key in Kibo.KEY_NAMES_BY_CODE) {
    if (Object.prototype.hasOwnProperty.call(Kibo.KEY_NAMES_BY_CODE, key)) {
      Kibo.KEY_CODES_BY_NAME[Kibo.KEY_NAMES_BY_CODE[key]] = +key;
    }
  }
})();
Kibo.MODIFIERS = ['shift', 'ctrl', 'alt'];
Kibo.registerEvent = function () {
  if (document.addEventListener) {
    return function (element, eventName, func) {
      element.addEventListener(eventName, func, false);
    };
  } else if (document.attachEvent) {
    return function (element, eventName, func) {
      element.attachEvent('on' + eventName, func);
    };
  }
}();
Kibo.unregisterEvent = function () {
  if (document.removeEventListener) {
    return function (element, eventName, func) {
      element.removeEventListener(eventName, func, false);
    };
  } else if (document.detachEvent) {
    return function (element, eventName, func) {
      element.detachEvent('on' + eventName, func);
    };
  }
}();
Kibo.stringContains = function (string, substring) {
  return string.indexOf(substring) !== -1;
};
Kibo.neatString = function (string) {
  return string.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
};
Kibo.capitalize = function (string) {
  return string.toLowerCase().replace(/^./, function (match) {
    return match.toUpperCase();
  });
};
Kibo.isString = function (what) {
  return Kibo.stringContains(Object.prototype.toString.call(what), 'String');
};
Kibo.arrayIncludes = function () {
  if (Array.prototype.indexOf) {
    return function (haystack, needle) {
      return haystack.indexOf(needle) !== -1;
    };
  } else {
    return function (haystack, needle) {
      for (var i = 0; i < haystack.length; i++) {
        if (haystack[i] === needle) {
          return true;
        }
      }
      return false;
    };
  }
}();
Kibo.extractModifiers = function (keyCombination) {
  var modifiers, i;
  modifiers = [];
  for (i = 0; i < Kibo.MODIFIERS.length; i++) {
    if (Kibo.stringContains(keyCombination, Kibo.MODIFIERS[i])) {
      modifiers.push(Kibo.MODIFIERS[i]);
    }
  }
  return modifiers;
};
Kibo.extractKey = function (keyCombination) {
  var keys, i;
  keys = Kibo.neatString(keyCombination).split(' ');
  for (i = 0; i < keys.length; i++) {
    if (!Kibo.arrayIncludes(Kibo.MODIFIERS, keys[i])) {
      return keys[i];
    }
  }
};
Kibo.modifiersAndKey = function (keyCombination) {
  var result, key;
  if (Kibo.stringContains(keyCombination, 'any')) {
    return Kibo.neatString(keyCombination).split(' ').slice(0, 2).join(' ');
  }
  result = Kibo.extractModifiers(keyCombination);
  key = Kibo.extractKey(keyCombination);
  if (key && !Kibo.arrayIncludes(Kibo.MODIFIERS, key)) {
    result.push(key);
  }
  return result.join(' ');
};
Kibo.keyName = function (keyCode) {
  return Kibo.KEY_NAMES_BY_CODE[keyCode + ''];
};
Kibo.keyCode = function (keyName) {
  return +Kibo.KEY_CODES_BY_NAME[keyName];
};
Kibo.prototype.initialize = function () {
  var i,
    that = this;
  this.lastKeyCode = -1;
  this.lastModifiers = {};
  for (i = 0; i < Kibo.MODIFIERS.length; i++) {
    this.lastModifiers[Kibo.MODIFIERS[i]] = false;
  }
  this.keysDown = {
    any: []
  };
  this.keysUp = {
    any: []
  };
  this.downHandler = this.handler('down');
  this.upHandler = this.handler('up');
  Kibo.registerEvent(this.element, 'keydown', this.downHandler);
  Kibo.registerEvent(this.element, 'keyup', this.upHandler);
  var unloadEvent = typeof window.onbeforeunload === 'object' ? 'beforeunload' : 'unload';
  Kibo.registerEvent(window, unloadEvent, function unloader() {
    Kibo.unregisterEvent(that.element, 'keydown', that.downHandler);
    Kibo.unregisterEvent(that.element, 'keyup', that.upHandler);
    Kibo.unregisterEvent(window, unloadEvent, unloader);
  });
};
Kibo.prototype.handler = function (upOrDown) {
  var that = this;
  return function (e) {
    var i, registeredKeys, lastModifiersAndKey;
    e = e || window.event;
    that.lastKeyCode = e.keyCode;
    for (i = 0; i < Kibo.MODIFIERS.length; i++) {
      that.lastModifiers[Kibo.MODIFIERS[i]] = e[Kibo.MODIFIERS[i] + 'Key'];
    }
    if (Kibo.arrayIncludes(Kibo.MODIFIERS, Kibo.keyName(that.lastKeyCode))) {
      that.lastModifiers[Kibo.keyName(that.lastKeyCode)] = true;
    }
    registeredKeys = that['keys' + Kibo.capitalize(upOrDown)];
    for (i = 0; i < registeredKeys.any.length; i++) {
      if (registeredKeys.any[i](e) === false && e.preventDefault) {
        e.preventDefault();
      }
    }
    lastModifiersAndKey = that.lastModifiersAndKey();
    if (registeredKeys[lastModifiersAndKey]) {
      for (i = 0; i < registeredKeys[lastModifiersAndKey].length; i++) {
        if (registeredKeys[lastModifiersAndKey][i](e) === false && e.preventDefault) {
          e.preventDefault();
        }
      }
    }
  };
};
Kibo.prototype.registerKeys = function (upOrDown, newKeys, func) {
  var i,
    keys,
    registeredKeys = this['keys' + Kibo.capitalize(upOrDown)];
  if (Kibo.isString(newKeys)) {
    newKeys = [newKeys];
  }
  for (i = 0; i < newKeys.length; i++) {
    keys = newKeys[i];
    keys = Kibo.modifiersAndKey(keys + '');
    if (registeredKeys[keys]) {
      registeredKeys[keys].push(func);
    } else {
      registeredKeys[keys] = [func];
    }
  }
  return this;
};

// jshint maxdepth:5
Kibo.prototype.unregisterKeys = function (upOrDown, newKeys, func) {
  var i,
    j,
    keys,
    registeredKeys = this['keys' + Kibo.capitalize(upOrDown)];
  if (Kibo.isString(newKeys)) {
    newKeys = [newKeys];
  }
  for (i = 0; i < newKeys.length; i++) {
    keys = newKeys[i];
    keys = Kibo.modifiersAndKey(keys + '');
    if (func === null) {
      delete registeredKeys[keys];
    } else {
      if (registeredKeys[keys]) {
        for (j = 0; j < registeredKeys[keys].length; j++) {
          if (String(registeredKeys[keys][j]) === String(func)) {
            registeredKeys[keys].splice(j, 1);
            break;
          }
        }
      }
    }
  }
  return this;
};
Kibo.prototype.off = function (keys) {
  return this.unregisterKeys('down', keys, null);
};
Kibo.prototype.delegate = function (upOrDown, keys, func) {
  return func !== null || func !== undefined ? this.registerKeys(upOrDown, keys, func) : this.unregisterKeys(upOrDown, keys, func);
};
Kibo.prototype.down = function (keys, func) {
  return this.delegate('down', keys, func);
};
Kibo.prototype.up = function (keys, func) {
  return this.delegate('up', keys, func);
};
Kibo.prototype.lastKey = function (modifier) {
  if (!modifier) {
    return Kibo.keyName(this.lastKeyCode);
  }
  return this.lastModifiers[modifier];
};
Kibo.prototype.lastModifiersAndKey = function () {
  var result, i;
  result = [];
  for (i = 0; i < Kibo.MODIFIERS.length; i++) {
    if (this.lastKey(Kibo.MODIFIERS[i])) {
      result.push(Kibo.MODIFIERS[i]);
    }
  }
  if (!Kibo.arrayIncludes(result, this.lastKey())) {
    result.push(this.lastKey());
  }
  return result.join(' ');
};

var index = {
  Kibo
};

var css_248z$4 = ".media-control-notransition {\n  transition: none !important;\n}\n\n.media-control[data-media-control] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  pointer-events: none;\n}\n.media-control[data-media-control].dragging {\n  pointer-events: auto;\n  cursor: grabbing !important;\n  cursor: url(\"closed-hand.cur\"), move;\n}\n.media-control[data-media-control].dragging * {\n  cursor: grabbing !important;\n  cursor: url(\"closed-hand.cur\"), move;\n}\n.media-control[data-media-control] .media-control-background[data-background] {\n  position: absolute;\n  height: 40%;\n  width: 100%;\n  bottom: 0;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));\n  will-change: transform, opacity;\n  transition: opacity 0.6s ease-out;\n}\n.media-control[data-media-control] .media-control-icon {\n  line-height: 0;\n  letter-spacing: 0;\n  speak: none;\n  color: #fff;\n  opacity: 0.5;\n  vertical-align: middle;\n  text-align: left;\n  transition: all 0.1s ease;\n}\n.media-control[data-media-control] .media-control-icon:hover {\n  color: white;\n  opacity: 0.75;\n  text-shadow: rgba(255, 255, 255, 0.8) 0 0 5px;\n}\n.media-control[data-media-control].media-control-hide .media-control-background[data-background] {\n  opacity: 0;\n}\n.media-control[data-media-control].media-control-hide .media-control-layer[data-controls] {\n  transform: translateY(50px);\n}\n.media-control[data-media-control].media-control-hide .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n  opacity: 0;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] {\n  position: absolute;\n  transform: translateY(-7px);\n  bottom: 0;\n  width: 100%;\n  height: 32px;\n  font-size: 0;\n  vertical-align: middle;\n  pointer-events: auto;\n  transition: bottom 0.4s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-left-panel[data-media-control] {\n  position: absolute;\n  top: 0;\n  left: 4px;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-center-panel[data-media-control] {\n  height: 100%;\n  text-align: center;\n  line-height: 32px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-right-panel[data-media-control] {\n  position: absolute;\n  top: 0;\n  right: 4px;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button {\n  background-color: transparent;\n  border: 0;\n  margin: 0 6px;\n  padding: 0;\n  cursor: pointer;\n  display: inline-block;\n  width: 32px;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button svg {\n  width: 100%;\n  height: 22px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button svg path {\n  fill: white;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button:focus {\n  outline: none;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-play] {\n  float: left;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-pause] {\n  float: left;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-stop] {\n  float: left;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-fullscreen] {\n  float: right;\n  background-color: transparent;\n  border: 0;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator] {\n  background-color: transparent;\n  border: 0;\n  cursor: default;\n  display: none;\n  float: right;\n  height: 100%;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator].enabled {\n  display: block;\n  opacity: 1;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator].enabled:hover {\n  opacity: 1;\n  text-shadow: none;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-playpause] {\n  float: left;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-playstop] {\n  float: left;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-position], .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration] {\n  display: inline-block;\n  font-size: 10px;\n  color: white;\n  cursor: default;\n  line-height: 32px;\n  position: relative;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-position] {\n  margin: 0 6px 0 7px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration]:before {\n  content: \"|\";\n  margin-right: 7px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration] {\n  color: rgba(255, 255, 255, 0.5);\n  margin-right: 6px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] {\n  position: absolute;\n  top: -20px;\n  left: 0;\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  height: 25px;\n  cursor: pointer;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] {\n  width: 100%;\n  height: 1px;\n  position: relative;\n  top: 12px;\n  background-color: #666666;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: #c2c2c2;\n  transition: all 0.1s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: #005aff;\n  transition: all 0.1s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n  opacity: 0;\n  position: absolute;\n  top: -3px;\n  width: 5px;\n  height: 7px;\n  background-color: rgba(255, 255, 255, 0.5);\n  transition: opacity 0.1s ease;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n  opacity: 1;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar].seek-disabled {\n  cursor: default;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar].seek-disabled:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n  opacity: 0;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n  position: absolute;\n  transform: translateX(-50%);\n  top: 2px;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  opacity: 1;\n  transition: all 0.1s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n  position: absolute;\n  left: 6px;\n  top: 6px;\n  width: 8px;\n  height: 8px;\n  border-radius: 10px;\n  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.2);\n  background-color: white;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] {\n  float: right;\n  display: inline-block;\n  height: 32px;\n  cursor: pointer;\n  margin: 0 6px;\n  box-sizing: border-box;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] {\n  float: left;\n  bottom: 0;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] {\n  background-color: transparent;\n  border: 0;\n  box-sizing: content-box;\n  width: 32px;\n  height: 32px;\n  opacity: 0.5;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume]:hover {\n  opacity: 0.75;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] svg {\n  height: 24px;\n  position: relative;\n  top: 3px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] svg path {\n  fill: white;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume].muted svg {\n  margin-left: 2px;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] {\n  float: left;\n  position: relative;\n  overflow: hidden;\n  top: 6px;\n  width: 42px;\n  height: 18px;\n  padding: 3px 0;\n  transition: width 0.2s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] {\n  height: 1px;\n  position: relative;\n  top: 7px;\n  margin: 0 3px;\n  background-color: #666666;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-fill-1[data-volume] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: #c2c2c2;\n  transition: all 0.1s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-fill-2[data-volume] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: #005aff;\n  transition: all 0.1s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-hover[data-volume] {\n  opacity: 0;\n  position: absolute;\n  top: -3px;\n  width: 5px;\n  height: 7px;\n  background-color: rgba(255, 255, 255, 0.5);\n  transition: opacity 0.1s ease;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-scrubber[data-volume] {\n  position: absolute;\n  transform: translateX(-50%);\n  top: 0px;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  opacity: 1;\n  transition: all 0.1s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-scrubber[data-volume] .bar-scrubber-icon[data-volume] {\n  position: absolute;\n  left: 6px;\n  top: 6px;\n  width: 8px;\n  height: 8px;\n  border-radius: 10px;\n  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.2);\n  background-color: white;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume] {\n  float: left;\n  width: 4px;\n  padding-left: 2px;\n  height: 12px;\n  opacity: 0.5;\n  box-shadow: inset 2px 0 0 white;\n  transition: transform 0.2s ease-out;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume].fill {\n  box-shadow: inset 2px 0 0 #fff;\n  opacity: 1;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume]:nth-of-type(1) {\n  padding-left: 0;\n}\n.media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume]:hover {\n  transform: scaleY(1.5);\n}\n.media-control[data-media-control].w320 .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume].volume-bar-hide {\n  width: 0;\n  height: 12px;\n  top: 9px;\n  padding: 0;\n}";

var mediaControlHTML = "<div class=\"media-control-background\" data-background></div>\n<div class=\"media-control-layer\" data-controls>\n  <%  var renderBar = function(name) { %>\n      <div class=\"bar-container\" data-<%= name %>>\n        <div class=\"bar-background\" data-<%= name %>>\n          <div class=\"bar-fill-1\" data-<%= name %>></div>\n          <div class=\"bar-fill-2\" data-<%= name %>></div>\n          <div class=\"bar-hover\" data-<%= name %>></div>\n        </div>\n        <div class=\"bar-scrubber\" data-<%= name %>>\n          <div class=\"bar-scrubber-icon\" data-<%= name %>></div>\n        </div>\n      </div>\n  <%  }; %>\n  <%  var renderSegmentedBar = function(name, segments) {\n      segments = segments || 10; %>\n    <div class=\"bar-container\" data-<%= name %>>\n    <% for (var i = 0; i < segments; i++) { %>\n      <div class=\"segmented-bar-element\" data-<%= name %>></div>\n    <% } %>\n    </div>\n  <% }; %>\n  <% var renderDrawer = function(name, renderContent) { %>\n      <div class=\"drawer-container\" data-<%= name %>>\n        <div class=\"drawer-icon-container\" data-<%= name %>>\n          <div class=\"drawer-icon media-control-icon\" data-<%= name %>></div>\n          <span class=\"drawer-text\" data-<%= name %>></span>\n        </div>\n        <% renderContent(name); %>\n      </div>\n  <% }; %>\n  <% var renderIndicator = function(name) { %>\n      <div class=\"media-control-indicator\" data-<%= name %>></div>\n  <% }; %>\n  <% var renderButton = function(name) { %>\n    <button type=\"button\" class=\"media-control-button media-control-icon\" data-<%= name %> aria-label=\"<%= name %>\"></button>\n  <% }; %>\n  <%  var templates = {\n        bar: renderBar,\n        segmentedBar: renderSegmentedBar,\n      };\n      var render = function(settingsList) {\n        settingsList.forEach(function(setting) {\n          if(setting === \"seekbar\") {\n            renderBar(setting);\n          } else if (setting === \"volume\") {\n            renderDrawer(setting, settings.volumeBarTemplate ? templates[settings.volumeBarTemplate] : function(name) { return renderSegmentedBar(name); });\n          } else if (setting === \"duration\" || setting === \"position\") {\n            renderIndicator(setting);\n          } else {\n            renderButton(setting);\n          }\n        });\n      }; %>\n  <% if (settings.default && settings.default.length) { %>\n  <div class=\"media-control-center-panel\" data-media-control>\n    <% render(settings.default); %>\n  </div>\n  <% } %>\n  <% if (settings.left && settings.left.length) { %>\n  <div class=\"media-control-left-panel\" data-media-control>\n    <% render(settings.left); %>\n  </div>\n  <% } %>\n  <% if (settings.right && settings.right.length) { %>\n  <div class=\"media-control-right-panel\" data-media-control>\n    <% render(settings.right); %>\n  </div>\n  <% } %>\n</div>\n";

var stopIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 1.24h12.6v13.52h-12.6z\"/>\n</svg>";

var volumeIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M11.5 11h-.002v1.502L7.798 10H4.5V6h3.297l3.7-2.502V4.5h.003V11zM11 4.49L7.953 6.5H5v3h2.953L11 11.51V4.49z\"/>\n</svg>";

var volumeMuteIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M9.75 11.51L6.7 9.5H3.75v-3H6.7L9.75 4.49v.664l.497.498V3.498L6.547 6H3.248v4h3.296l3.7 2.502v-2.154l-.497.5v.662zm3-5.165L12.404 6l-1.655 1.653L9.093 6l-.346.345L10.402 8 8.747 9.654l.346.347 1.655-1.653L12.403 10l.348-.346L11.097 8l1.655-1.655z\"/>\n</svg>";

var fullscreenIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M7.156 8L4 11.156V8.5H3V13h4.5v-1H4.844L8 8.844 7.156 8zM8.5 3v1h2.657L8 7.157 8.846 8 12 4.844V7.5h1V3H8.5z\"/>\n</svg>";

var exitFullscreenIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M13.5 3.344l-.844-.844L9.5 5.656V3h-1v4.5H13v-1h-2.656L13.5 3.344zM3 9.5h2.656L2.5 12.656l.844.844L6.5 10.344V13h1V8.5H3v1z\"/>\n</svg>";

var hdIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M5.375 7.062H2.637V4.26H.502v7.488h2.135V8.9h2.738v2.848h2.133V4.26H5.375v2.802zm5.97-2.81h-2.84v7.496h2.798c2.65 0 4.195-1.607 4.195-3.77v-.022c0-2.162-1.523-3.704-4.154-3.704zm2.06 3.758c0 1.21-.81 1.896-2.03 1.896h-.83V6.093h.83c1.22 0 2.03.696 2.03 1.896v.02z\"/>\n</svg>";

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

const {
  Config,
  Fullscreen,
  formatTime: formatTime$1,
  extend,
  removeArrayItem
} = Utils;
const defaultVolumeState = 100;
class MediaControl extends UICorePlugin {
  get name() {
    return 'media_control';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get disabled() {
    const playbackIsNOOP = this.container && this.container.getPlaybackType() === Playback.NO_OP;
    return this.userDisabled || playbackIsNOOP;
  }
  get container() {
    return this.core && this.core.activeContainer;
  }
  get playback() {
    return this.core && this.core.activePlayback;
  }
  get attributes() {
    return {
      'class': 'media-control',
      'data-media-control': ''
    };
  }
  get events() {
    return {
      'click [data-play]': 'play',
      'click [data-pause]': 'pause',
      'click [data-playpause]': 'togglePlayPause',
      'click [data-stop]': 'stop',
      'click [data-playstop]': 'togglePlayStop',
      'click [data-fullscreen]': 'toggleFullscreen',
      'click .bar-container[data-seekbar]': 'seek',
      'click .bar-container[data-volume]': 'onVolumeClick',
      'click .drawer-icon[data-volume]': 'toggleMute',
      'mouseenter .drawer-container[data-volume]': 'showVolumeBar',
      'mouseleave .drawer-container[data-volume]': 'hideVolumeBar',
      'mousedown .bar-container[data-volume]': 'startVolumeDrag',
      'mousemove .bar-container[data-volume]': 'mousemoveOnVolumeBar',
      'mousedown .bar-scrubber[data-seekbar]': 'startSeekDrag',
      'mousemove .bar-container[data-seekbar]': 'mousemoveOnSeekBar',
      'mouseleave .bar-container[data-seekbar]': 'mouseleaveOnSeekBar',
      'mouseenter .media-control-layer[data-controls]': 'setUserKeepVisible',
      'mouseleave .media-control-layer[data-controls]': 'resetUserKeepVisible'
    };
  }
  get template() {
    return template(mediaControlHTML);
  }
  get volume() {
    return this.container && this.container.isReady ? this.container.volume : this.intendedVolume;
  }
  get muted() {
    return this.volume === 0;
  }
  constructor(core) {
    super(core);
    this.persistConfig = this.options.persistConfig;
    this._previousVolumeState = null;
    this.currentPositionValue = null;
    this.currentDurationValue = null;
    this.keepVisible = false;
    this.fullScreenOnVideoTagSupported = null; // unknown
    this.setInitialVolume();
    this.settings = {
      left: ['play', 'stop', 'pause'],
      right: ['volume'],
      default: ['position', 'seekbar', 'duration']
    };
    this.kibo = new Kibo(this.options.focusElement);
    this.bindKeyEvents();
    if (this.container) {
      if (!$.isEmptyObject(this.container.settings)) {
        this.settings = $.extend({}, this.container.settings);
      }
    } else {
      this.settings = {};
    }
    this.userDisabled = false;
    if (this.container && this.container.mediaControlDisabled || this.options.chromeless) {
      this.disable();
    }
    this.stopDragHandler = event => this.stopDrag(event);
    this.updateDragHandler = event => this.updateDrag(event);
    $(document).bind('mouseup', this.stopDragHandler);
    $(document).bind('mousemove', this.updateDragHandler);
  }
  getExternalInterface() {
    return {
      setVolume: this.setVolume,
      getVolume: () => this.volume
    };
  }
  bindEvents() {
    this.stopListening();
    this.listenTo(this.core, Events.CORE_ACTIVE_CONTAINER_CHANGED, this.onActiveContainerChanged);
    this.listenTo(this.core, Events.CORE_MOUSE_MOVE, this.show);
    this.listenTo(this.core, Events.CORE_MOUSE_LEAVE, () => this.hide(this.options.hideMediaControlDelay));
    this.listenTo(this.core, Events.CORE_FULLSCREEN, this.show);
    this.listenTo(this.core, Events.CORE_OPTIONS_CHANGE, this.configure);
    this.listenTo(this.core, Events.CORE_RESIZE, this.playerResize);
    this.bindContainerEvents();
  }
  bindContainerEvents() {
    if (!this.container) return;
    this.listenTo(this.container, Events.CONTAINER_PLAY, this.changeTogglePlay);
    this.listenTo(this.container, Events.CONTAINER_PAUSE, this.changeTogglePlay);
    this.listenTo(this.container, Events.CONTAINER_STOP, this.changeTogglePlay);
    this.listenTo(this.container, Events.CONTAINER_DBLCLICK, this.toggleFullscreen);
    this.listenTo(this.container, Events.CONTAINER_TIMEUPDATE, this.onTimeUpdate);
    this.listenTo(this.container, Events.CONTAINER_PROGRESS, this.updateProgressBar);
    this.listenTo(this.container, Events.CONTAINER_SETTINGSUPDATE, this.settingsUpdate);
    this.listenTo(this.container, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, this.settingsUpdate);
    this.listenTo(this.container, Events.CONTAINER_HIGHDEFINITIONUPDATE, this.highDefinitionUpdate);
    this.listenTo(this.container, Events.CONTAINER_MEDIACONTROL_DISABLE, this.disable);
    this.listenTo(this.container, Events.CONTAINER_MEDIACONTROL_ENABLE, this.enable);
    this.listenTo(this.container, Events.CONTAINER_ENDED, this.ended);
    this.listenTo(this.container, Events.CONTAINER_VOLUME, this.onVolumeChanged);
    this.listenTo(this.container, Events.CONTAINER_OPTIONS_CHANGE, this.setInitialVolume);
    if (this.container.playback.el.nodeName.toLowerCase() === 'video') {
      // wait until the metadata has loaded and then check if fullscreen on video tag is supported
      this.listenToOnce(this.container, Events.CONTAINER_LOADEDMETADATA, this.onLoadedMetadataOnVideoTag);
    }
  }
  disable() {
    this.userDisabled = true;
    this.hide();
    this.unbindKeyEvents();
    this.$el.hide();
  }
  enable() {
    if (this.options.chromeless) return;
    this.userDisabled = false;
    this.bindKeyEvents();
    this.show();
  }
  play() {
    this.container && this.container.play();
  }
  pause() {
    this.container && this.container.pause();
  }
  stop() {
    this.container && this.container.stop();
  }
  setInitialVolume() {
    this._previousVolumeState = null;
    const initialVolume = this.persistConfig ? Config.restore('volume') : 100;
    const options = this.container && this.container.options || this.options;
    this.setVolume(options.mute ? 0 : initialVolume, true);
  }
  onVolumeChanged() {
    this.updateVolumeUI();
  }
  onLoadedMetadataOnVideoTag() {
    const video = this.playback && this.playback.el;
    // video.webkitSupportsFullscreen is deprecated but iOS appears to only use this
    // see https://github.com/clappr/clappr/issues/1127
    if (!Fullscreen.fullscreenEnabled() && video.webkitSupportsFullscreen) {
      this.fullScreenOnVideoTagSupported = true;
      this.settingsUpdate();
    }
  }
  updateVolumeUI() {
    // this will be called after a render
    if (!this.rendered) return;

    // update volume bar scrubber/fill on bar mode
    this.$volumeBarContainer.find('.bar-fill-2').css({});
    const containerWidth = this.$volumeBarContainer.width();
    const barWidth = this.$volumeBarBackground.width();
    const offset = (containerWidth - barWidth) / 2.0;
    const pos = barWidth * this.volume / 100.0 + offset;
    this.$volumeBarFill.css({
      width: `${this.volume}%`
    });
    this.$volumeBarScrubber.css({
      left: pos
    });

    // update volume bar segments on segmented bar mode
    this.$volumeBarContainer.find('.segmented-bar-element').removeClass('fill');
    const item = Math.ceil(this.volume / 10.0);
    this.$volumeBarContainer.find('.segmented-bar-element').slice(0, item).addClass('fill');
    this.$volumeIcon.html('');
    this.$volumeIcon.removeClass('muted');
    if (!this.muted) {
      this.$volumeIcon.append(volumeIcon);
    } else {
      this.$volumeIcon.append(volumeMuteIcon);
      this.$volumeIcon.addClass('muted');
    }
    this.applyButtonStyle(this.$volumeIcon);
  }
  changeTogglePlay() {
    this.$playPauseToggle.html('');
    this.$playStopToggle.html('');
    if (this.container && this.container.isPlaying()) {
      this.$playPauseToggle.append(pauseIcon);
      this.$playStopToggle.append(stopIcon);
      this.trigger(Events.MEDIACONTROL_PLAYING);
    } else {
      this.$playPauseToggle.append(playIcon);
      this.$playStopToggle.append(playIcon);
      this.trigger(Events.MEDIACONTROL_NOTPLAYING);
      Browser.isMobile && this.show();
    }
    this.applyButtonStyle(this.$playPauseToggle);
    this.applyButtonStyle(this.$playStopToggle);
  }
  mousemoveOnSeekBar(event) {
    if (this.settings.seekEnabled) {
      const offsetX = event.pageX - this.$seekBarContainer.offset().left - this.$seekBarHover.width() / 2;
      this.$seekBarHover.css({
        left: offsetX
      });
    }
    this.trigger(Events.MEDIACONTROL_MOUSEMOVE_SEEKBAR, event);
  }
  mouseleaveOnSeekBar(event) {
    this.trigger(Events.MEDIACONTROL_MOUSELEAVE_SEEKBAR, event);
  }
  onVolumeClick(event) {
    this.setVolume(this.getVolumeFromUIEvent(event));
  }
  mousemoveOnVolumeBar(event) {
    this.draggingVolumeBar && this.setVolume(this.getVolumeFromUIEvent(event));
  }
  playerResize(size) {
    this.$fullscreenToggle.html('');
    const icon = this.core.isFullscreen() ? exitFullscreenIcon : fullscreenIcon;
    this.$fullscreenToggle.append(icon);
    this.applyButtonStyle(this.$fullscreenToggle);
    this.$el.find('.media-control').length !== 0 && this.$el.removeClass('w320');
    if (size.width <= 320 || this.options.hideVolumeBar) this.$el.addClass('w320');
  }
  togglePlayPause() {
    this.container.isPlaying() ? this.container.pause() : this.container.play();
    return false;
  }
  togglePlayStop() {
    this.container.isPlaying() ? this.container.stop() : this.container.play();
  }
  startSeekDrag(event) {
    if (!this.settings.seekEnabled) return;
    this.draggingSeekBar = true;
    this.$el.addClass('dragging');
    this.$seekBarLoaded.addClass('media-control-notransition');
    this.$seekBarPosition.addClass('media-control-notransition');
    this.$seekBarScrubber.addClass('media-control-notransition');
    event && event.preventDefault();
  }
  startVolumeDrag(event) {
    this.draggingVolumeBar = true;
    this.$el.addClass('dragging');
    event && event.preventDefault();
  }
  stopDrag(event) {
    this.draggingSeekBar && this.seek(event);
    this.$el.removeClass('dragging');
    this.$seekBarLoaded.removeClass('media-control-notransition');
    this.$seekBarPosition.removeClass('media-control-notransition');
    this.$seekBarScrubber.removeClass('media-control-notransition dragging');
    this.draggingSeekBar = false;
    this.draggingVolumeBar = false;
  }
  updateDrag(event) {
    if (this.draggingSeekBar) {
      event.preventDefault();
      const offsetX = event.pageX - this.$seekBarContainer.offset().left;
      let pos = offsetX / this.$seekBarContainer.width() * 100;
      pos = Math.min(100, Math.max(pos, 0));
      this.setSeekPercentage(pos);
    } else if (this.draggingVolumeBar) {
      event.preventDefault();
      this.setVolume(this.getVolumeFromUIEvent(event));
    }
  }
  getVolumeFromUIEvent(event) {
    const offsetY = event.pageX - this.$volumeBarContainer.offset().left;
    const volumeFromUI = offsetY / this.$volumeBarContainer.width() * 100;
    return volumeFromUI;
  }
  toggleMute() {
    if (this.muted) {
      const stored = this._previousVolumeState;
      this._previousVolumeState = null;
      const restore = stored != null && stored > 0 ? stored : defaultVolumeState;
      this.setVolume(restore);
      return;
    }
    const current = this.volume;
    this._previousVolumeState = current > 0 ? current : null;
    this.setVolume(0);
  }
  setVolume(value, isInitialVolume = false) {
    value = Math.min(100, Math.max(value, 0));
    // this will hold the intended volume
    // it may not actually get set to this straight away
    // if the container is not ready etc
    this.intendedVolume = value;
    this.persistConfig && !isInitialVolume && Config.persist('volume', value);
    const setWhenContainerReady = () => {
      if (this.container && this.container.isReady) {
        this.container.setVolume(value);
      } else {
        this.listenToOnce(this.container, Events.CONTAINER_READY, () => {
          this.container.setVolume(value);
        });
      }
    };
    if (!this.container) {
      this.listenToOnce(this, Events.MEDIACONTROL_CONTAINERCHANGED, () => setWhenContainerReady());
    } else {
      setWhenContainerReady();
    }
  }
  toggleFullscreen() {
    this.trigger(Events.MEDIACONTROL_FULLSCREEN, this.name);
    this.container.fullscreen();
    this.core.toggleFullscreen();
    this.resetUserKeepVisible();
  }
  onActiveContainerChanged() {
    this.fullScreenOnVideoTagSupported = null;
    this.bindEvents();
    // set the new container to match the volume of the last one
    this.setInitialVolume();
    this.changeTogglePlay();
    this.bindContainerEvents();
    this.settingsUpdate();
    this.container && this.container.trigger(Events.CONTAINER_PLAYBACKDVRSTATECHANGED, this.container.isDvrInUse());
    this.container && this.container.mediaControlDisabled && this.disable();
    this.trigger(Events.MEDIACONTROL_CONTAINERCHANGED);
  }
  showVolumeBar() {
    this.hideVolumeId && clearTimeout(this.hideVolumeId);
    this.$volumeBarContainer.removeClass('volume-bar-hide');
  }
  hideVolumeBar(timeout = 400) {
    if (!this.$volumeBarContainer) return;
    if (this.draggingVolumeBar) {
      this.hideVolumeId = setTimeout(() => this.hideVolumeBar(), timeout);
    } else {
      this.hideVolumeId && clearTimeout(this.hideVolumeId);
      this.hideVolumeId = setTimeout(() => this.$volumeBarContainer.addClass('volume-bar-hide'), timeout);
    }
  }
  ended() {
    this.changeTogglePlay();
  }
  updateProgressBar(progress) {
    const loadedStart = progress.start / progress.total * 100;
    const loadedEnd = progress.current / progress.total * 100;
    this.$seekBarLoaded.css({
      left: `${loadedStart}%`,
      width: `${loadedEnd - loadedStart}%`
    });
  }
  onTimeUpdate(timeProgress) {
    if (this.draggingSeekBar) return;
    // TODO why should current time ever be negative?
    const position = timeProgress.current < 0 ? timeProgress.total : timeProgress.current;
    this.currentPositionValue = position;
    this.currentDurationValue = timeProgress.total;
    this.renderSeekBar();
  }
  renderSeekBar() {
    // this will be triggered as soon as these become available
    if (this.currentPositionValue === null || this.currentDurationValue === null) return;

    // default to 100%
    this.currentSeekBarPercentage = 100;
    if (this.container && (this.container.getPlaybackType() !== Playback.LIVE || this.container.isDvrInUse())) {
      this.currentSeekBarPercentage = this.currentPositionValue / this.currentDurationValue * 100;
    }
    this.setSeekPercentage(this.currentSeekBarPercentage);
    const newPosition = formatTime$1(this.currentPositionValue);
    const newDuration = formatTime$1(this.currentDurationValue);
    if (newPosition !== this.displayedPosition) {
      this.$position.text(newPosition);
      this.displayedPosition = newPosition;
    }
    if (newDuration !== this.displayedDuration) {
      this.$duration.text(newDuration);
      this.displayedDuration = newDuration;
    }
  }
  seek(event) {
    if (!this.settings.seekEnabled) return;
    const offsetX = event.pageX - this.$seekBarContainer.offset().left;
    let pos = offsetX / this.$seekBarContainer.width() * 100;
    pos = Math.min(100, Math.max(pos, 0));
    this.container && this.container.seekPercentage(pos);
    this.setSeekPercentage(pos);
    return false;
  }
  setKeepVisible() {
    this.keepVisible = true;
  }
  resetKeepVisible() {
    this.keepVisible = false;
  }
  setUserKeepVisible() {
    this.userKeepVisible = true;
  }
  resetUserKeepVisible() {
    this.userKeepVisible = false;
  }
  isVisible() {
    return !this.$el.hasClass('media-control-hide');
  }
  show(event) {
    if (this.disabled) return;
    const timeout = 2000;
    const mousePointerMoved = event && event.clientX !== this.lastMouseX && event.clientY !== this.lastMouseY;
    if (!event || mousePointerMoved || navigator.userAgent.match(/firefox/i)) {
      clearTimeout(this.hideId);
      this.$el.show();
      this.trigger(Events.MEDIACONTROL_SHOW, this.name);
      this.container && this.container.trigger(Events.CONTAINER_MEDIACONTROL_SHOW, this.name);
      this.$el.removeClass('media-control-hide');
      this.hideId = setTimeout(() => this.hide(), timeout);
      if (event) {
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
      }
    }
    const showing = true;
    this.updateCursorStyle(showing);
  }
  hide(delay = 0) {
    if (!this.isVisible()) return;
    const timeout = delay || 2000;
    clearTimeout(this.hideId);
    if (!this.disabled && this.options.hideMediaControl === false) return;
    const hasKeepVisibleRequested = this.userKeepVisible || this.keepVisible;
    const hasDraggingAction = this.draggingSeekBar || this.draggingVolumeBar;
    if (!this.disabled && (delay || hasKeepVisibleRequested || hasDraggingAction)) {
      this.hideId = setTimeout(() => this.hide(), timeout);
    } else {
      this.trigger(Events.MEDIACONTROL_HIDE, this.name);
      this.container && this.container.trigger(Events.CONTAINER_MEDIACONTROL_HIDE, this.name);
      this.$el.addClass('media-control-hide');
      this.hideVolumeBar(0);
      const showing = false;
      this.updateCursorStyle(showing);
    }
  }
  updateCursorStyle(showing) {
    if (showing) {
      this.core.$el.removeClass('nocursor');
    } else if (this.core.isFullscreen()) {
      this.core.$el.addClass('nocursor');
    }
  }
  settingsUpdate() {
    const newSettings = this.getSettings();
    if (newSettings && !this.fullScreenOnVideoTagSupported && !Fullscreen.fullscreenEnabled()) {
      // remove fullscreen from settings if it is present
      newSettings.default && removeArrayItem(newSettings.default, 'fullscreen');
      newSettings.left && removeArrayItem(newSettings.left, 'fullscreen');
      newSettings.right && removeArrayItem(newSettings.right, 'fullscreen');
    }
    const settingsChanged = JSON.stringify(this.settings) !== JSON.stringify(newSettings);
    if (settingsChanged) {
      this.settings = newSettings;
      this.render();
    }
  }
  getSettings() {
    return $.extend(true, {}, this.container && this.container.settings);
  }
  highDefinitionUpdate(isHD) {
    this.isHD = isHD;
    const method = isHD ? 'addClass' : 'removeClass';
    this.$hdIndicator[method]('enabled');
  }
  createCachedElements() {
    const $layer = this.$el.find('.media-control-layer');
    this.$duration = $layer.find('.media-control-indicator[data-duration]');
    this.$fullscreenToggle = $layer.find('button.media-control-button[data-fullscreen]');
    this.$playPauseToggle = $layer.find('button.media-control-button[data-playpause]');
    this.$playStopToggle = $layer.find('button.media-control-button[data-playstop]');
    this.$position = $layer.find('.media-control-indicator[data-position]');
    this.$seekBarContainer = $layer.find('.bar-container[data-seekbar]');
    this.$seekBarHover = $layer.find('.bar-hover[data-seekbar]');
    this.$seekBarLoaded = $layer.find('.bar-fill-1[data-seekbar]');
    this.$seekBarPosition = $layer.find('.bar-fill-2[data-seekbar]');
    this.$seekBarScrubber = $layer.find('.bar-scrubber[data-seekbar]');
    this.$volumeBarContainer = $layer.find('.bar-container[data-volume]');
    this.$volumeContainer = $layer.find('.drawer-container[data-volume]');
    this.$volumeIcon = $layer.find('.drawer-icon[data-volume]');
    this.$volumeBarBackground = this.$el.find('.bar-background[data-volume]');
    this.$volumeBarFill = this.$el.find('.bar-fill-1[data-volume]');
    this.$volumeBarScrubber = this.$el.find('.bar-scrubber[data-volume]');
    this.$hdIndicator = this.$el.find('button.media-control-button[data-hd-indicator]');
    this.resetIndicators();
    this.initializeIcons();
  }
  resetIndicators() {
    this.displayedPosition = this.$position.text();
    this.displayedDuration = this.$duration.text();
  }
  initializeIcons() {
    const $layer = this.$el.find('.media-control-layer');
    $layer.find('button.media-control-button[data-play]').append(playIcon);
    $layer.find('button.media-control-button[data-pause]').append(pauseIcon);
    $layer.find('button.media-control-button[data-stop]').append(stopIcon);
    this.$playPauseToggle.append(playIcon);
    this.$playStopToggle.append(playIcon);
    this.$volumeIcon.append(volumeIcon);
    this.$fullscreenToggle.append(fullscreenIcon);
    this.$hdIndicator.append(hdIcon);
  }
  setSeekPercentage(value) {
    value = Math.max(Math.min(value, 100.0), 0);
    // not changed since last update
    if (this.displayedSeekBarPercentage === value) return;
    this.displayedSeekBarPercentage = value;
    this.$seekBarPosition.removeClass('media-control-notransition');
    this.$seekBarScrubber.removeClass('media-control-notransition');
    this.$seekBarPosition.css({
      width: `${value}%`
    });
    this.$seekBarScrubber.css({
      left: `${value}%`
    });
  }
  seekRelative(delta) {
    if (!this.settings.seekEnabled) return;
    const currentTime = this.container.getCurrentTime();
    const duration = this.container.getDuration();
    let position = Math.min(Math.max(currentTime + delta, 0), duration);
    position = Math.min(position * 100 / duration, 100);
    this.container.seekPercentage(position);
  }
  bindKeyAndShow(key, callback) {
    this.kibo.down(key, () => {
      this.show();
      return callback();
    });
  }
  bindKeyEvents() {
    if (Browser.isMobile || this.options.disableKeyboardShortcuts) return;
    this.unbindKeyEvents();
    this.kibo = new Kibo(this.options.focusElement || this.options.parentElement);
    this.bindKeyAndShow('space', () => this.togglePlayPause());
    this.bindKeyAndShow('left', () => this.seekRelative(-5));
    this.bindKeyAndShow('right', () => this.seekRelative(5));
    this.bindKeyAndShow('shift left', () => this.seekRelative(-10));
    this.bindKeyAndShow('shift right', () => this.seekRelative(10));
    this.bindKeyAndShow('shift ctrl left', () => this.seekRelative(-15));
    this.bindKeyAndShow('shift ctrl right', () => this.seekRelative(15));
    const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    keys.forEach(i => {
      this.bindKeyAndShow(i, () => {
        this.settings.seekEnabled && this.container && this.container.seekPercentage(i * 10);
      });
    });
  }
  unbindKeyEvents() {
    if (this.kibo) {
      this.kibo.off('space');
      this.kibo.off('left');
      this.kibo.off('right');
      this.kibo.off('shift left');
      this.kibo.off('shift right');
      this.kibo.off('shift ctrl left');
      this.kibo.off('shift ctrl right');
      this.kibo.off(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']);
    }
  }
  parseColors() {
    if (this.options.mediacontrol) {
      this.buttonsColor = this.options.mediacontrol.buttons;
      const seekbarColor = this.options.mediacontrol.seekbar;
      this.$el.find('.bar-fill-2[data-seekbar]').css('background-color', seekbarColor);
      this.$el.find('.media-control-icon svg path').css('fill', this.buttonsColor);
      this.$el.find('.segmented-bar-element[data-volume]').css('boxShadow', 'inset 2px 0 0 ' + this.buttonsColor);
    }
  }
  applyButtonStyle(element) {
    this.buttonsColor && element && $(element).find('svg path').css('fill', this.buttonsColor);
  }
  destroy() {
    $(document).unbind('mouseup', this.stopDragHandler);
    $(document).unbind('mousemove', this.updateDragHandler);
    this.unbindKeyEvents();
    this.stopListening();
    super.destroy();
  }

  /**
   * enables to configure the media control after its creation
   * @method configure
   * @param {Object} options all the options to change in form of a javascript object
   */
  configure(options) {
    // Check if chromeless mode or if configure is called with new source(s)
    if (this.options.chromeless || options.source || options.sources) {
      this.disable();
    } else {
      this.enable();
    }
    this.trigger(Events.MEDIACONTROL_OPTIONS_CHANGE);
  }
  render() {
    const timeout = this.options.hideMediaControlDelay || 2000;
    this.settings && this.$el.html(this.template({
      settings: this.settings
    }));
    const style = Styler.getStyleFor(css_248z$4, {
      baseUrl: this.options.baseUrl
    });
    this.$el.append(style[0]);
    this.createCachedElements();
    this.$playPauseToggle.addClass('paused');
    this.$playStopToggle.addClass('stopped');
    this.changeTogglePlay();
    if (this.container) {
      this.hideId = setTimeout(() => this.hide(), timeout);
      this.disabled && this.hide();
    }

    // Video volume cannot be changed with Safari on mobile devices
    // Display mute/unmute icon only if Safari version >= 10
    if (Browser.isSafari && Browser.isMobile) {
      if (Browser.version < 10) {
        this.$volumeContainer.css('display', 'none');
      } else {
        this.$volumeBarContainer.css('display', 'none');
      }
    }
    this.$seekBarPosition.addClass('media-control-notransition');
    this.$seekBarScrubber.addClass('media-control-notransition');
    let previousSeekPercentage = 0;
    if (this.displayedSeekBarPercentage) {
      previousSeekPercentage = this.displayedSeekBarPercentage;
    }
    this.displayedSeekBarPercentage = null;
    this.setSeekPercentage(previousSeekPercentage);
    setTimeout(() => {
      !this.settings.seekEnabled && this.$seekBarContainer.addClass('seek-disabled');
      !Browser.isMobile && !this.options.disableKeyboardShortcuts && this.bindKeyEvents();
      this.playerResize({
        width: this.options.width,
        height: this.options.height
      });
      this.hideVolumeBar(0);
    }, 0);
    this.parseColors();
    this.highDefinitionUpdate(this.isHD);
    this.core.$el.append(this.el);
    this.rendered = true;
    this.updateVolumeUI();
    this.trigger(Events.MEDIACONTROL_RENDERED);
    return this;
  }
}
MediaControl.extend = function (properties) {
  return extend(MediaControl, properties);
};

var posterHTML = "<div class=\"play-wrapper\" data-poster></div>\n";

var css_248z$3 = ".player-poster[data-poster] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 998;\n  top: 0;\n  left: 0;\n  background-color: transparent;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n}\n.player-poster[data-poster].clickable {\n  cursor: pointer;\n}\n.player-poster[data-poster]:hover .play-wrapper[data-poster] {\n  opacity: 1;\n}\n.player-poster[data-poster] .play-wrapper[data-poster] {\n  width: 100%;\n  height: 25%;\n  margin: 0 auto;\n  opacity: 0.75;\n  transition: opacity 0.1s ease;\n}\n.player-poster[data-poster] .play-wrapper[data-poster] svg {\n  height: 100%;\n}\n.player-poster[data-poster] .play-wrapper[data-poster] svg path {\n  fill: #fff;\n}";

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

class PosterPlugin extends UIContainerPlugin {
  get name() {
    return 'poster';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get template() {
    return template(posterHTML);
  }
  get shouldRender() {
    const showForNoOp = !!(this.options.poster && this.options.poster.showForNoOp);
    return this.container.playback.name !== 'html_img' && (this.container.playback.getPlaybackType() !== Playback.NO_OP || showForNoOp);
  }
  get attributes() {
    return {
      'class': 'player-poster',
      'data-poster': ''
    };
  }
  get events() {
    return {
      'click': 'clicked'
    };
  }
  get showOnVideoEnd() {
    return !this.options.poster || this.options.poster.showOnVideoEnd || this.options.poster.showOnVideoEnd === undefined;
  }
  constructor(container) {
    super(container);
    this.hasStartedPlaying = false;
    this.playRequested = false;
    this.render();
    setTimeout(() => this.update(), 0);
  }
  bindEvents() {
    this.listenTo(this.container, Events.CONTAINER_STOP, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_PLAY, this.onPlay);
    this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERING, this.update);
    this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERFULL, this.update);
    this.listenTo(this.container, Events.CONTAINER_OPTIONS_CHANGE, this.render);
    this.listenTo(this.container, Events.CONTAINER_ERROR, this.onError);
    this.showOnVideoEnd && this.listenTo(this.container, Events.CONTAINER_ENDED, this.onStop);
  }
  onError(error) {
    this.hasFatalError = error.level === PlayerError.Levels.FATAL;
    if (this.hasFatalError) {
      this.hasStartedPlaying = false;
      this.playRequested = false;
      this.showPlayButton();
    }
  }
  onPlay() {
    this.hasStartedPlaying = true;
    this.update();
  }
  onStop() {
    this.hasStartedPlaying = false;
    this.playRequested = false;
    this.update();
  }
  updatePlayButton(show) {
    if (show && (!this.options.chromeless || this.options.allowUserInteraction)) {
      this.showPlayButton();
    } else {
      this.hidePlayButton();
    }
  }
  showPlayButton() {
    if (this.hasFatalError && !this.options.disableErrorScreen) return;
    this.$playButton.show();
    this.$el.addClass('clickable');
  }
  hidePlayButton() {
    this.$playButton.hide();
    this.$el.removeClass('clickable');
  }
  clicked() {
    // Let "click_to_pause" plugin handle click event if media has started playing
    if (!this.hasStartedPlaying) {
      if (!this.options.chromeless || this.options.allowUserInteraction) {
        this.playRequested = true;
        this.update();
        this.container.playback && (this.container.playback._consented = true);
        this.container.play();
      }
      return false;
    }
  }
  shouldHideOnPlay() {
    // Audio broadcasts should keep the poster up; video should hide poster while playing.
    return !this.container.playback.isAudioOnly;
  }
  update() {
    if (!this.shouldRender) {
      return;
    }
    const showPlayButton = !this.playRequested && !this.hasStartedPlaying && !this.container.buffering;
    this.updatePlayButton(showPlayButton);
    this.updatePoster();
  }
  updatePoster() {
    if (!this.hasStartedPlaying) this.showPoster();else this.hidePoster();
  }
  showPoster() {
    this.container.disableMediaControl();
    this.$el.show();
  }
  hidePoster() {
    this.container.enableMediaControl();
    if (this.shouldHideOnPlay()) {
      this.$el.hide();
    }
  }
  render() {
    if (!this.shouldRender) {
      return;
    }
    const style = Styler.getStyleFor(css_248z$3, {
      baseUrl: this.options.baseUrl
    });
    this.$el.html(this.template());
    this.$el.append(style[0]);
    const isRegularPoster = this.options.poster && this.options.poster.custom === undefined;
    if (isRegularPoster) {
      const posterUrl = this.options.poster.url || this.options.poster;
      this.$el.css({
        'background-image': 'url(' + posterUrl + ')'
      });
      this.removeVideoElementPoster();
    } else if (this.options.poster) {
      this.$el.css({
        'background': this.options.poster.custom
      });
      this.removeVideoElementPoster();
    }
    this.container.$el.append(this.el);
    this.$playWrapper = this.$el.find('.play-wrapper');
    this.$playWrapper.append(playIcon);
    this.$playButton = this.$playWrapper.find('svg');
    this.$playButton.addClass('poster-icon');
    this.$playButton.attr('data-poster', '');
    let buttonsColor = this.options.mediacontrol && this.options.mediacontrol.buttons;
    if (buttonsColor) {
      this.$el.find('svg path').css('fill', buttonsColor);
    }
    if (this.options.mediacontrol && this.options.mediacontrol.buttons) {
      buttonsColor = this.options.mediacontrol.buttons;
      this.$playButton.css('color', buttonsColor);
    }
    this.update();
    return this;
  }
  removeVideoElementPoster() {
    this.container.playback && this.container.playback.$el && this.container.playback.$el[0] && this.container.playback.$el[0].removeAttribute && this.container.playback.$el[0].removeAttribute('poster');
  }
}

var seekTimeHTML = "<span data-seek-time></span>\n<span data-duration></span>\n";

var css_248z$2 = ".seek-time[data-seek-time] {\n  position: absolute;\n  white-space: nowrap;\n  height: 20px;\n  line-height: 20px;\n  font-size: 0;\n  left: -100%;\n  bottom: 55px;\n  background-color: rgba(2, 2, 2, 0.5);\n  z-index: 9999;\n  transition: opacity 0.1s ease;\n}\n.seek-time[data-seek-time].hidden[data-seek-time] {\n  opacity: 0;\n}\n.seek-time[data-seek-time] [data-seek-time] {\n  display: inline-block;\n  color: white;\n  font-size: 10px;\n  padding-left: 7px;\n  padding-right: 7px;\n  vertical-align: top;\n}\n.seek-time[data-seek-time] [data-duration] {\n  display: inline-block;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 10px;\n  padding-right: 7px;\n  vertical-align: top;\n}\n.seek-time[data-seek-time] [data-duration]:before {\n  content: \"|\";\n  margin-right: 7px;\n}";

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

const {
  formatTime
} = Utils;
class SeekTime extends UICorePlugin {
  get name() {
    return 'seek_time';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get template() {
    return template(seekTimeHTML);
  }
  get attributes() {
    return {
      'class': 'seek-time',
      'data-seek-time': ''
    };
  }
  get mediaControl() {
    return this.core.mediaControl;
  }
  get mediaControlContainer() {
    return this.mediaControl.container;
  }
  get isLiveStreamWithDvr() {
    return this.mediaControlContainer && this.mediaControlContainer.getPlaybackType() === Playback.LIVE && this.mediaControlContainer.isDvrEnabled();
  }
  get durationShown() {
    return this.isLiveStreamWithDvr && !this.actualLiveTime;
  }
  get useActualLiveTime() {
    return this.actualLiveTime && this.isLiveStreamWithDvr;
  }
  constructor(core) {
    super(core);
    this.hoveringOverSeekBar = false;
    this.hoverPosition = null;
    this.duration = null;
    this.firstFragDateTime = null;
    this.actualLiveTime = !!this.mediaControl.options.actualLiveTime;
    if (this.actualLiveTime) {
      if (this.mediaControl.options.actualLiveServerTime) {
        this.actualLiveServerTimeDiff = new Date().getTime() - new Date(this.mediaControl.options.actualLiveServerTime).getTime();
      } else {
        this.actualLiveServerTimeDiff = 0;
      }
    }
  }
  bindEvents() {
    this.listenTo(this.mediaControl, Events.MEDIACONTROL_RENDERED, this.render);
    this.listenTo(this.mediaControl, Events.MEDIACONTROL_MOUSEMOVE_SEEKBAR, this.showTime);
    this.listenTo(this.mediaControl, Events.MEDIACONTROL_MOUSELEAVE_SEEKBAR, this.hideTime);
    this.listenTo(this.mediaControl, Events.MEDIACONTROL_CONTAINERCHANGED, this.onContainerChanged);
    if (this.mediaControlContainer) {
      this.listenTo(this.mediaControlContainer, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, this.update);
      this.listenTo(this.mediaControlContainer, Events.CONTAINER_TIMEUPDATE, this.updateDuration);
    }
  }
  onContainerChanged() {
    this.stopListening();
    this.bindEvents();
  }
  updateDuration(timeProgress) {
    this.duration = timeProgress.total;
    this.firstFragDateTime = timeProgress.firstFragDateTime;
    this.update();
  }
  showTime(event) {
    this.hoveringOverSeekBar = true;
    this.calculateHoverPosition(event);
    this.update();
  }
  hideTime() {
    this.hoveringOverSeekBar = false;
    this.update();
  }
  calculateHoverPosition(event) {
    const offset = event.pageX - this.mediaControl.$seekBarContainer.offset().left;
    // proportion into the seek bar that the mouse is hovered over 0-1
    this.hoverPosition = Math.min(1, Math.max(offset / this.mediaControl.$seekBarContainer.width(), 0));
  }
  getSeekTime() {
    let seekTime, secondsSinceMidnight, d, e;
    if (this.useActualLiveTime) {
      if (this.firstFragDateTime) {
        e = new Date(this.firstFragDateTime);
        d = new Date(this.firstFragDateTime);
        d.setHours(0, 0, 0, 0);
        secondsSinceMidnight = (e.getTime() - d.getTime()) / 1000 + this.duration;
      } else {
        d = new Date(new Date().getTime() - this.actualLiveServerTimeDiff);
        e = new Date(d);
        secondsSinceMidnight = (e - d.setHours(0, 0, 0, 0)) / 1000;
      }
      seekTime = secondsSinceMidnight - this.duration + this.hoverPosition * this.duration;
      if (seekTime < 0) {
        seekTime += 86400;
      }
    } else {
      seekTime = this.hoverPosition * this.duration;
    }
    return {
      seekTime,
      secondsSinceMidnight
    };
  }
  update() {
    if (!this.rendered) {
      // update() is always called after a render
      return;
    }
    if (!this.shouldBeVisible()) {
      this.$el.hide();
      this.$el.css('left', '-100%');
    } else {
      const seekTime = this.getSeekTime();
      const currentSeekTime = formatTime(seekTime.seekTime, this.useActualLiveTime);
      // only update dom if necessary, ie time actually changed
      if (currentSeekTime !== this.displayedSeekTime) {
        this.$seekTimeEl.text(currentSeekTime);
        this.displayedSeekTime = currentSeekTime;
      }
      if (this.durationShown) {
        this.$durationEl.show();
        const currentDuration = formatTime(this.actualLiveTime ? seekTime.secondsSinceMidnight : this.duration, this.actualLiveTime);
        if (currentDuration !== this.displayedDuration) {
          this.$durationEl.text(currentDuration);
          this.displayedDuration = currentDuration;
        }
      } else {
        this.$durationEl.hide();
      }

      // the element must be unhidden before its width is requested, otherwise it's width will be reported as 0
      this.$el.show();
      const containerWidth = this.mediaControl.$seekBarContainer.width();
      const elWidth = this.$el.width();
      let elLeftPos = this.hoverPosition * containerWidth;
      elLeftPos -= elWidth / 2;
      elLeftPos = Math.max(0, Math.min(elLeftPos, containerWidth - elWidth));
      this.$el.css('left', elLeftPos);
    }
  }
  shouldBeVisible() {
    return this.mediaControlContainer && this.mediaControlContainer.settings.seekEnabled && this.hoveringOverSeekBar && this.hoverPosition !== null && this.duration !== null;
  }
  render() {
    const style = Styler.getStyleFor(css_248z$2, {
      baseUrl: this.options.baseUrl
    });
    this.rendered = true;
    this.displayedDuration = null;
    this.displayedSeekTime = null;
    this.$el.html(this.template());
    this.$el.append(style[0]);
    this.$el.hide();
    this.mediaControl.$el.append(this.el);
    this.$seekTimeEl = this.$el.find('[data-seek-time]');
    this.$durationEl = this.$el.find('[data-duration]');
    this.$durationEl.hide();
    this.update();
  }
}

var spinnerHTML = "<div data-bounce1></div><div data-bounce2></div><div data-bounce3></div>\n";

var css_248z$1 = ".spinner-three-bounce[data-spinner] {\n  position: absolute;\n  margin: 0 auto;\n  width: 70px;\n  text-align: center;\n  z-index: 999;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  /* center vertically */\n  top: 50%;\n  transform: translateY(-50%);\n}\n.spinner-three-bounce[data-spinner] > div {\n  width: 18px;\n  height: 18px;\n  background-color: #FFFFFF;\n  border-radius: 100%;\n  display: inline-block;\n  animation: bouncedelay 1.4s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  animation-fill-mode: both;\n}\n.spinner-three-bounce[data-spinner] [data-bounce1] {\n  animation-delay: -0.32s;\n}\n.spinner-three-bounce[data-spinner] [data-bounce2] {\n  animation-delay: -0.16s;\n}\n\n@keyframes bouncedelay {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}";

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

class SpinnerThreeBouncePlugin extends UIContainerPlugin {
  get name() {
    return 'spinner';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get attributes() {
    return {
      'data-spinner': '',
      'class': 'spinner-three-bounce'
    };
  }
  constructor(container) {
    super(container);
    this.template = template(spinnerHTML);
    this.showTimeout = null;
    this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERING, this.onBuffering);
    this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERFULL, this.onBufferFull);
    this.listenTo(this.container, Events.CONTAINER_STOP, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_ENDED, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_ERROR, this.onStop);
    this.render();
  }
  onBuffering() {
    this.show();
  }
  onBufferFull() {
    this.hide();
  }
  onStop() {
    this.hide();
  }
  show() {
    if (this.showTimeout === null) {
      this.showTimeout = setTimeout(() => this.$el.show(), 300);
    }
  }
  hide() {
    if (this.showTimeout !== null) {
      clearTimeout(this.showTimeout);
      this.showTimeout = null;
    }
    this.$el.hide();
  }
  render() {
    const style = Styler.getStyleFor(css_248z$1, {
      baseUrl: this.options.baseUrl
    });
    this.$el.html(this.template());
    this.$el.append(style[0]);
    this.container.$el.append(this.$el);
    this.$el.hide();
    if (this.container.buffering) {
      this.onBuffering();
    }
    return this;
  }
}

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

class StatsPlugin extends ContainerPlugin {
  get name() {
    return 'stats';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  constructor(container) {
    super(container);
    this.setInitialAttrs();
    this.reportInterval = this.options.reportInterval || 5000;
    this.state = 'IDLE';
  }
  bindEvents() {
    this.listenTo(this.container.playback, Events.PLAYBACK_PLAY, this.onPlay);
    this.listenTo(this.container, Events.CONTAINER_STOP, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_ENDED, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_DESTROYED, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERING, this.onBuffering);
    this.listenTo(this.container, Events.CONTAINER_STATE_BUFFERFULL, this.onBufferFull);
    this.listenTo(this.container, Events.CONTAINER_STATS_ADD, this.onStatsAdd);
    this.listenTo(this.container, Events.CONTAINER_BITRATE, this.onStatsAdd);
    this.listenTo(this.container.playback, Events.PLAYBACK_STATS_ADD, this.onStatsAdd);
  }
  setInitialAttrs() {
    this.firstPlay = true;
    this.startupTime = 0;
    this.rebufferingTime = 0;
    this.watchingTime = 0;
    this.rebuffers = 0;
    this.externalMetrics = {};
  }
  onPlay() {
    this.state = 'PLAYING';
    this.watchingTimeInit = Date.now();
    if (!this.intervalId) {
      this.intervalId = setInterval(this.report.bind(this), this.reportInterval);
    }
  }
  onStop() {
    clearInterval(this.intervalId);
    this.report();
    this.intervalId = undefined;
    this.state = 'STOPPED';
  }
  onBuffering() {
    if (this.firstPlay) {
      this.startupTimeInit = Date.now();
    } else {
      this.rebufferingTimeInit = Date.now();
    }
    this.state = 'BUFFERING';
    this.rebuffers++;
  }
  onBufferFull() {
    if (this.firstPlay && this.startupTimeInit) {
      this.firstPlay = false;
      this.startupTime = Date.now() - this.startupTimeInit;
      this.watchingTimeInit = Date.now();
    } else if (this.rebufferingTimeInit) {
      this.rebufferingTime += this.getRebufferingTime();
    }
    this.rebufferingTimeInit = undefined;
    this.state = 'PLAYING';
  }
  getRebufferingTime() {
    return Date.now() - this.rebufferingTimeInit;
  }
  getWatchingTime() {
    const totalTime = Date.now() - this.watchingTimeInit;
    return totalTime - this.rebufferingTime;
  }
  isRebuffering() {
    return !!this.rebufferingTimeInit;
  }
  onStatsAdd(metric) {
    $.extend(this.externalMetrics, metric);
  }
  getStats() {
    const metrics = {
      startupTime: this.startupTime,
      rebuffers: this.rebuffers,
      rebufferingTime: this.isRebuffering() ? this.rebufferingTime + this.getRebufferingTime() : this.rebufferingTime,
      watchingTime: this.isRebuffering() ? this.getWatchingTime() - this.getRebufferingTime() : this.getWatchingTime()
    };
    $.extend(metrics, this.externalMetrics);
    return metrics;
  }
  report() {
    this.container.statsReport(this.getStats());
  }
}

var watermarkHTML = "<div class=\"clappr-watermark\" data-watermark data-watermark-<%=position %>>\n<% if(typeof imageLink !== 'undefined') { %>\n<a target=\"_blank\" href=\"<%= imageLink %>\">\n<% } %>\n<img src=\"<%= imageUrl %>\">\n<% if(typeof imageLink !== 'undefined') { %>\n</a>\n<% } %>\n</div>\n";

var css_248z = ".clappr-watermark[data-watermark] {\n  position: absolute;\n  min-width: 70px;\n  max-width: 200px;\n  width: 12%;\n  text-align: center;\n  z-index: 10;\n}\n\n.clappr-watermark[data-watermark] a {\n  outline: none;\n  cursor: pointer;\n}\n\n.clappr-watermark[data-watermark] img {\n  max-width: 100%;\n}\n\n.clappr-watermark[data-watermark-bottom-left] {\n  bottom: 10px;\n  left: 10px;\n}\n\n.clappr-watermark[data-watermark-bottom-right] {\n  bottom: 10px;\n  right: 42px;\n}\n\n.clappr-watermark[data-watermark-top-left] {\n  top: 10px;\n  left: 10px;\n}\n\n.clappr-watermark[data-watermark-top-right] {\n  top: 10px;\n  right: 37px;\n}";

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

class WaterMarkPlugin extends UIContainerPlugin {
  get name() {
    return 'watermark';
  }
  get supportedVersion() {
    return {
      min: "0.14.7"
    };
  }
  get template() {
    return template(watermarkHTML);
  }
  constructor(container) {
    super(container);
    this.configure();
  }
  bindEvents() {
    this.listenTo(this.container, Events.CONTAINER_PLAY, this.onPlay);
    this.listenTo(this.container, Events.CONTAINER_STOP, this.onStop);
    this.listenTo(this.container, Events.CONTAINER_OPTIONS_CHANGE, this.configure);
  }
  configure() {
    this.position = this.options.position || 'bottom-right';
    if (this.options.watermark) {
      this.imageUrl = this.options.watermark;
      this.imageLink = this.options.watermarkLink;
      this.render();
    } else {
      this.$el.remove();
    }
  }
  onPlay() {
    if (!this.hidden) {
      this.$el.show();
    }
  }
  onStop() {
    this.$el.hide();
  }
  render() {
    this.$el.hide();
    const style = Styler.getStyleFor(css_248z, {
      baseUrl: this.options.baseUrl
    });
    const templateOptions = {
      position: this.position,
      imageUrl: this.imageUrl,
      imageLink: this.imageLink
    };
    this.$el.html(this.template(templateOptions));
    this.$el.append(style[0]);
    this.container.$el.append(this.$el);
    return this;
  }
}

// Copyright 2014 Globo.com Player authors. All rights reserved.
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file.

const version = "0.9.7";
const Plugins = {
  ClickToPause: ClickToPausePlugin,
  ClosedCaptions,
  DVRControls,
  EndVideo,
  ErrorScreen,
  Favicon,
  GoogleAnalytics,
  MediaControl,
  Poster: PosterPlugin,
  SeekTime,
  SpinnerThreeBounce: SpinnerThreeBouncePlugin,
  Stats: StatsPlugin,
  WaterMark: WaterMarkPlugin
};

export { ClickToPausePlugin as ClickToPause, ClosedCaptions, DVRControls, EndVideo, ErrorScreen, Favicon, GoogleAnalytics, MediaControl, Plugins, PosterPlugin as Poster, SeekTime, SpinnerThreeBouncePlugin as SpinnerThreeBounce, StatsPlugin as Stats, index as Vendor, WaterMarkPlugin as WaterMark, version };
